import { useTranslation } from "react-i18next";

import appstoreFooter from "../../assets/app-store-footer.svg";
import googlePlayFooter from "../../assets/google-play-footer.svg";
import facebook from "../../assets/icons/facebook.svg";
import instagram from "../../assets/icons/instagram.svg";
import linkedin from "../../assets/icons/linkedin.svg";
import twitter from "../../assets/icons/twitter.svg";
import youtube from "../../assets/icons/youtube.svg";
import { DropdownLanguage } from "../../components/dropdown-language";
import { LinkType, getLink } from "../../links";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t, i18n } = useTranslation();

  return (
    <footer className="sticky top-[100vh] mx-4  my-4 p-4" data-testid="footer">
      <div className="flex justify-between items-center md:items-end flex-col gap-4 md:flex-row">
        <ul className="flex flex-wrap gap-2">
          <li>
            <a
              target="_blank"
              href={getLink({
                linkType: LinkType.GooglePlay,
                language: i18n.language,
              })}
            >
              <img src={googlePlayFooter} alt="GooglePlay" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href={getLink({
                linkType: LinkType.AppStore,
                language: i18n.language,
              })}
            >
              <img src={appstoreFooter} alt="AppStore" />
            </a>
          </li>
        </ul>
        <ul className="flex flex-wrap gap-2">
          <li>
            <a
              target="_blank"
              href={getLink({
                linkType: LinkType.Facebook,
                language: i18n.language,
              })}
            >
              <img src={facebook} alt="Facebook" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href={getLink({
                linkType: LinkType.Instagram,
                language: i18n.language,
              })}
            >
              <img src={instagram} alt="Instagram" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href={getLink({
                linkType: LinkType.LinkedIn,
                language: i18n.language,
              })}
            >
              <img src={linkedin} alt="LinkedIn" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href={getLink({
                linkType: LinkType.Twitter,
                language: i18n.language,
              })}
            >
              <img src={twitter} alt="Twitter" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href={getLink({
                linkType: LinkType.Youtube,
                language: i18n.language,
              })}
            >
              <img src={youtube} alt="Youtube" />
            </a>
          </li>
        </ul>
      </div>
      <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-500 lg:my-8" />
      <div className="grid grid-cols-1 gap-3 items-center md:grid-cols-5">
        <div className="col-span-1 flex justify-center md:justify-start">
          <span className="md:mr-6 text-gray-700 text-xs font-normal">
            © {currentYear} Cobee™
          </span>
        </div>
        <div className="col-span-3">
          <ul className="flex flex-wrap justify-center items-center  text-gray-700 text-sm font-medium sm:mb-0">
            <li>
              <a
                target="_blank"
                href={getLink({
                  linkType: LinkType.TermsAndConditions,
                  language: i18n.language,
                })}
                className="mr-4 hover:underline md:mr-6 "
              >
                {t("footer.terms-conditions")}
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href={getLink({
                  linkType: LinkType.PrivacyPolicy,
                  language: i18n.language,
                })}
                className="mr-4 hover:underline md:mr-6 font-medium"
              >
                {t("footer.privacy-policy")}
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href={getLink({
                  linkType: LinkType.ContactUs,
                  language: i18n.language,
                })}
                className="mr-4 hover:underline md:mr-6 "
              >
                {t("footer.contact-us")}
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href={getLink({
                  linkType: LinkType.HelpCenter,
                  language: i18n.language,
                })}
                className="mr-4 hover:underline md:mr-6 "
              >
                {t("footer.help-center")}
              </a>
            </li>
          </ul>
        </div>
        <div className="col-span-1 flex justify-center md:justify-end">
          <DropdownLanguage isFooter={true} />
        </div>
      </div>
    </footer>
  );
};
export { Footer };
